import styled from 'styled-components';
import FooterImage from 'common/src/assets/image/hosting/footer-bg.png';

const FooterWrapper = styled.footer`
  position: relative;
  color: #fff;
  background-color: #000;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    width: 106%;
    padding-bottom: 106%;
    border-top-right-radius: 11%;
    top: 22%;
    left: 0;
    pointer-events: none;
    background-color: #000;

    @media (max-width: 767px) {
      padding-bottom: 150%;
    }
  }

  @media (min-width: 576px) {
    background-color: #fff;
    padding-top: 130px;
    &:before {
      content: '';
      position: absolute;
      width: 106%;
      padding-bottom: 106%;
      border-top-right-radius: 11%;
      top: 22%;
      left: 0;
      pointer-events: none;
      background-color: #000;
      transform: rotate(-6deg);
      @media (max-width: 767px) {
        padding-bottom: 150%;
      }
    }
  }

  .footer_container {
    background-repeat: no-repeat;
    background-position: center 50px;
    padding-top: 80px;
    padding-bottom: 10px;
    position: relative;
    @media (min-width: 576px) {
      background-image: url(${FooterImage});
    }
    @media (max-width: 990px) {
      padding-bottom: 40px;
    }
    @media (max-width: 767px) {
      padding-bottom: 0px;
    }
  }
`;

const List = styled.ul``;

const ListItem = styled.li`
  a {
    color: #fff;
    font-size: 14px;
    line-height: 36px;
    transition: all 0.2s ease;
    &:hover,
    &:focus {
      outline: 0;
      text-decoration: underline;
      color: #fff;
    }
  }
`;

const InsightBox = styled.div`
  text-align: center;

  .title {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 15px;
  }

  .desc {
    font-size: 12px;
    margin-bottom: 15px;
  }

  .input {
    width: 100%;
    padding: 10px;
  }

  button {
    margin-top: 15px;
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
      #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-weight: 600;
    font-size: 15px;
    padding: 10px 30px;
    cursor: pointer;
    color: #000000;
  }
`;

const FooterBottom = styled.div`
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  justify-content: space-between;
  border-top: 1px solid #595959;
  padding: 10px 10px 0px 10px;

  .eq-width {
    margin: 0 10px;
    cursor: pointer;
  }

  a {
    color: #fff;
  }

  .text {
    width: 100%;
    text-align: center;
  }

  .icon {
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  @media (min-width: 768px) {
    flex-wrap: wrap;
  }

  @media (min-width: 992px) {
    flex-wrap: nowrap;

    .text {
      text-align: left;
    }
    .icon {
      padding: 0;
      text-align: right;
    }
  }
`;

export { List, ListItem, InsightBox, FooterBottom };

export default FooterWrapper;
